/**
 * Created by luckyli on 2018/03/30.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class extends Component {
    static propTypes = {
        name: PropTypes.string.isRequired,
        color: PropTypes.string,
        fontSize: PropTypes.string
    }
    render() {
        return <i className={'icon-'+this.props.name} style={Object.assign({}, {color: this.props.color}, {fontSize: this.props.size})}></i>
    }
}




// WEBPACK FOOTER //
// ./src/components/Common/Icon.js